export const sources = {
	webp: "__VITE_ASSET__P4DPfwIRieI8P6q8r4JZRw__ 500w, __VITE_ASSET__cn7IAAGY294pWGc7MpElVg__ 800w, __VITE_ASSET__VRAku6fjghkApIISiBWPzg__ 1080w, __VITE_ASSET__aLISaAY6NSiJFT$6GdtrfA__ 1090w"
};
export const img = {
	src: "__VITE_ASSET__aLISaAY6NSiJFT$6GdtrfA__",
	w: 1090,
	h: 842
};
export default {
	sources: sources,
	img: img
};
